import React from 'react';
const tags = ['U6', 'U8', 'U10', 'U12', 'U14', 'Tecnica', 'Tattica'];
export function SolutionSection() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-193">
      <div className="max-w-4xl mx-auto text-center" data-id="element-194">
        <div className="inline-flex items-center gap-2 bg-[#0A0A0A] text-white font-bold text-xs px-5 py-2 rounded-full mb-8 tracking-wider uppercase shadow-md" data-id="element-195">
          🏆 Il Sistema più Completo per Allenatori di Calcio Giovanile in
          Italia
        </div>

        <h2 className="text-4xl sm:text-6xl font-black text-[#0A0A0A] mb-4 tracking-tight" data-id="element-196">
          CALCIO GIOVANILE <span className="text-[#16A34A]" data-id="element-197">PRONTO™</span>
        </h2>

        <p className="text-[#0A0A0A] text-xl sm:text-2xl font-black mb-6" data-id="element-198">
          5 Volumi + 5 Bonus
        </p>

        <p className="text-[#5A5A66] text-base sm:text-lg max-w-2xl mx-auto mb-8 font-medium leading-relaxed" data-id="element-199">
          Oltre 250 pagine. 250 allenamenti completi. 300 esercizi
          professionali. Progressioni complete. Pianificazione stagionale.
          Gestione della squadra.{' '}
          <strong className="text-[#0A0A0A]" data-id="element-200">Tutto già pronto.</strong>
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-8 text-[#0A0A0A] text-sm sm:text-base font-black mb-10" data-id="element-201">
          <span className="flex items-center gap-2" data-id="element-202">📄 Oltre 250 pagine</span>
          <span className="hidden sm:inline text-[#E5E5EA]" data-id="element-203">|</span>
          <span className="flex items-center gap-2" data-id="element-204">⚽ 250 Allenamenti</span>
          <span className="hidden sm:inline text-[#E5E5EA]" data-id="element-205">|</span>
          <span className="flex items-center gap-2" data-id="element-206">🔥 300 Esercizi</span>
          <span className="hidden sm:inline text-[#E5E5EA]" data-id="element-207">|</span>
          <span className="flex items-center gap-2" data-id="element-208">🎯 U6-U14</span>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-209">
          {tags.map(tag => <span key={tag} className="bg-[#FAFAFA] border border-[#E5E5EA] text-[#0A0A0A] text-xs sm:text-sm font-bold px-4 py-2 rounded-full shadow-sm" data-id="element-210">
              {tag}
            </span>)}
        </div>
      </div>
    </section>;
}